import e from"../../node_modules/@mui/utils/esm/deepmerge/deepmerge.js";function m(m,o){return o?e(m,o,{clone:!1}):m}export{m as default};
//# sourceMappingURL=merge.js.map
